import { app } from '../../../app';
import { Controller } from './hard-token-sync.controller';

app.component('hardTokenSync', {
    templateUrl: require('./hard-token-sync.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-sync/hard-token-sync.component.js